import { Button, Layout, theme, Form, Input, Spin, notification } from "antd";

import React, { useEffect, useState, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";

const EditMCQ = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const getSingleQuestionset = useCallback(() => {
    QuestionnairesApi.SingleQuestionset(id)
      .then((response) => {
        setQuotations(response.payload?.questions);
        form.setFieldsValue({
          SetName: response?.payload?.questionSetsName,
          priority: response?.payload?.priority,
          passMark: response?.payload?.passMark,
          failMark: response?.payload?.failMark,
        });

        response.payload?.questions.map((item, index) => {
          form.setFieldsValue({
            [`AnswersType${index}`]: item?.answerType,
            [`Question${index}`]: item?.question,
            [`Mark${index}`]: item?.marks,
            [`Answer${index}`]: item?.options ? item.options : [],
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getSingleQuestionset();
  }, [getSingleQuestionset, PageLoading]);

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      totalNumberOfQuestions: quotations.length,
      questions: quotations,
      questionSetsName: data.SetName,
      priority: data.priority,
      passMark: data.passMark,
      failMark: data.failMark,
      questionnaireId: 1,
    });

    QuestionnairesApi.UpdateQuestionset(formData, id)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: (
            <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>
          ),
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/MCQ-management");
      })
      .catch((err) => {
        setLoadings(false);
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const [quotations, setQuotations] = useState([]);

  const handleChangeMarks = (quotationIndex, value) => {
    let total = 0;
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].marks = value;
    setQuotations(newQuotations);
    quotations.forEach((item) => {
      total += parseInt(item.marks);
    });
    form.setFieldsValue({
      passMark: total,
    });
  };
  const handleChangeQuestion = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].question = value;
    setQuotations(newQuotations);
  };

  const handleChangeOption = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].options = value;
    setQuotations(newQuotations);
  };

  const handleChangeAnswertype = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].answerType = value;
    newQuotations[quotationIndex].correctAnswer = null;
    setQuotations(newQuotations);
  };

  const handleChangeCorrectAnswer = (quotationIndex, value) => {
    let correctAnswer;
    if (typeof value === "object") {
      correctAnswer = value.join(",");
    } else {
      correctAnswer = value;
    }
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].correctAnswer = correctAnswer;
    setQuotations(newQuotations);
  };

  const handleAddQuotation = () => {
    setQuotations([
      ...quotations,
      {
        question: "",
        options: null,
        answerType: "RADIO",
        marks: "",
        correctAnswer: null,
      },
    ]);
  };

  const handleRemoveQuotation = (quotationIndex) => {
    const newQuotations = [...quotations];
    newQuotations.splice(quotationIndex, 1);
    setQuotations(newQuotations);
  };

  const validateInputNumber = (_, value) => {
    if (value >= 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Value must be greater than to 0"));
  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            form={form}
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="SetName"
                    label="Set Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Set Name.",
                      },
                      {
                        pattern: /^[A-Za-z\s]+$/,
                        message: "Only alphabet characters are allowed.",
                      },
                    ]}
                  >
                    <Input placeholder="Set Name" className="control-input" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                {/* <Col span={6}>
                  <Form.Item
                    name="TotalQuestions"
                    label="Total Number of Questions"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      placeholder="T.N of Questions"
                      className="control-input"
                    />
                  </Form.Item>
                </Col> */}
                <Col span={8}>
                  <Form.Item
                    name="priority"
                    label="Priority"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Priority.",
                      },
                      { validator: validateInputNumber },
                    ]}
                  >
                    <Input
                      type="text"
                      min={0}
                      readOnly
                      placeholder="Priority"
                      className="control-input"
                    />
                  </Form.Item>
                  <span style={{ color: "#083DCC" }}>
                    You can't change the priority. If you want to have a new
                    priority try creating a new one
                  </span>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Pass Mark"
                    name="passMark"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Pass Mark.",
                      },
                      { validator: validateInputNumber },
                    ]}
                  >
                    <Input
                      type="number"
                      readOnly
                      min={0}
                      placeholder="Pass Mark"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Fail Mark"
                    name="failMark"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Fail Mark.",
                      },
                      { validator: validateInputNumber },
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      placeholder="Fail Mark"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <div>
                    <div className="d-flex py-3 pt-4">
                      <h5>Questions</h5>
                      <Button
                        className="mx-4 btn btn-primary my-0 py-1 px-4"
                        onClick={handleAddQuotation}
                      >
                        +
                      </Button>
                    </div>
                    {quotations.map((quotation, quotationIndex) => (
                      <div key={quotationIndex}>
                        <Row gutter={16} className="mt-3">
                          <Col span={24}>

                            <h5>Question {quotationIndex + 1}</h5>
                            <div key={quotationIndex} className="d-flex">
                              <Form.Item
                                name={`Question${quotationIndex}`}
                                className="text-lable w-100"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Question.",
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    handleChangeQuestion(
                                      quotationIndex,
                                      e.target.value
                                    )
                                  }
                                  value={quotation?.question}
                                  placeholder={`Question ${quotationIndex + 1}`}
                                  className="control-input"
                                />
                              </Form.Item>
                              <Button
                                style={{ height: "42px" }}
                                className="btn btn-primary my-0 mx-3 px-4 pt-2"
                                onClick={() =>
                                  handleRemoveQuotation(quotationIndex)
                                }
                              >
                                -
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <div className="mx-4">
                          <Row gutter={16}>
                            <Col span={24}>
                              <Form.Item
                                name={`Answer${quotationIndex}`}
                                label="Answers"
                                className="text-lable w-100 mx-2"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Answers.",
                                  },
                                ]}
                              >
                                <Select
                                  onChange={(value) =>
                                    handleChangeOption(quotationIndex, value)
                                  }
                                  mode="tags"
                                  value={
                                    quotation?.options ? quotation.options : []
                                  }
                                  className="select-multi"
                                  tokenSeparators={[","]}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={9}>
                              <Form.Item
                                name={`AnswersType${quotationIndex}`}
                                label="Answer Type"
                                className="text-lable w-100 mx-2"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Answers Type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      quotationIndex,
                                      value
                                    )
                                  }
                                  value={
                                    quotation?.answerType === "RADIO"
                                      ? "RADIO"
                                      : "CHECKBOX"
                                  }
                                  placeholder="Select Answer Type"
                                  options={[
                                    { value: "RADIO", label: "Single Answer" },
                                    {
                                      value: "CHECKBOX",
                                      label: "Multiple Answer",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={9}>
                              <Form.Item
                                label="Mark"
                                name={`Mark${quotationIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Mark.",
                                  },
                                  { validator: validateInputNumber },
                                ]}
                              >
                                <Input
                                  type="number"
                                  min={0}
                                  value={quotation?.marks}
                                  onChange={(e) =>
                                    handleChangeMarks(
                                      quotationIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Mark"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={24}>
                              <Form.Item
                                label="Correct Answer"
                                className="text-lable w-100 mx-2"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Correct Answer.",
                                  },
                                ]}
                              >
                                {quotations[quotationIndex]?.answerType ==
                                  "RADIO" ? (
                                  <>
                                    <Select
                                      value={quotation?.correctAnswer}
                                      className="control-Select"
                                      onChange={(value) =>
                                        handleChangeCorrectAnswer(
                                          quotationIndex,
                                          value
                                        )
                                      }
                                      placeholder="Select Answer Type"
                                    >
                                      {quotations[quotationIndex]?.options && (
                                        <>
                                          {quotations[
                                            quotationIndex
                                          ]?.options.map((option, index) => (
                                            <option key={index} value={option}>
                                              {option}
                                            </option>
                                          ))}
                                        </>
                                      )}
                                    </Select>
                                  </>
                                ) : (
                                  <>
                                    {quotations[quotationIndex]?.options && (
                                      <>
                                        <Select
                                          mode="multiple"
                                          placeholder="Select Answer Type"
                                          value={
                                            quotation?.correctAnswer
                                              ? quotation.correctAnswer.split(
                                                ","
                                              )
                                              : []
                                          }
                                          className="select-multi"
                                          onChange={(value) =>
                                            handleChangeCorrectAnswer(
                                              quotationIndex,
                                              value
                                            )
                                          }
                                          options={quotations[
                                            quotationIndex
                                          ]?.options.map((item) => ({
                                            value: item,
                                            label: item,
                                          }))}
                                        />
                                      </>
                                    )}
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditMCQ;
